import React, { Component } from "react";
import { InputGroup, Input, Button } from "reactstrap";

const SearchBox = ({ Desktop, filters, advanced, setAdvanced, updateFilterValue }) => {
  return (
    <InputGroup>
      <div className="input-group-prepend">
        <span className="input-group-text">
          <i className="fa fa-search"></i>
        </span>
      </div>

      <Input
        type="text"
        placeholder="Search something"
        value={filters.text}
        onChange={(e) => updateFilterValue("text", e.target.value)}
      />
      {!advanced.open && (
        <Desktop>
          <div className="input-group-append">
            <Button type="button" color="primary" onClick={() => setAdvanced("open", !advanced.open)}>
              Advanced <i className="fa fa-caret-down"></i>
            </Button>
          </div>
        </Desktop>
      )}
    </InputGroup>
  );
};

export default SearchBox;
